// extracted by mini-css-extract-plugin
module.exports = {"labelBadgeListContainer":"LabelBadgeList_labelBadgeListContainer__cdqvb","labelBadgeWithMargin":"LabelBadgeList_labelBadgeWithMargin__d2f7M"};